import 'bootstrap/dist/css/bootstrap.min.css';
import './gutenberg.css';
import './App.css';

import Header from "./components/sections/Header";
import Home from "./components/pages/Home";
import Footer from "./components/sections/Footer";
import About from "./components/pages/About";
import Blog from "./components/pages/Blog";
import Locations from "./components/pages/Locations";
import Order from './components/pages/Order';
import Ourstory from "./components/pages/Ourstory";
import Learnmore from "./components/pages/Learnmore";
import Delivery from './components/pages/Delivery';
import Pickup from './components/pages/Pickup';
import BlogSingle from './components/pages/BlogSingle';
import { Route, Routes } from 'react-router-dom';




function App() {
  return (
    
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/about" element={<About/>}></Route>
        <Route path="/blog" element={<Blog/>}></Route>
        <Route path="/locations" element={<Locations/>}></Route>
        <Route path="/order" element={<Order/>}></Route>
        <Route path="/ourstory" element={<Ourstory/>}></Route>
        <Route path="/delivery" element={<Delivery/>}></Route>
        <Route path="/pickup" element={<Pickup/>}></Route>
       <Route path="/blog/:id" element={<BlogSingle />} />
        <Route path="/learnmore" element={<Learnmore />} />




      </Routes>





    

      
      <Footer />
    </div>
    
  );
}

export default App;
